"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
function propertyDefinition() {
    return [
        {
            sort_no: 1,
            name: "finsconductivity",
            group: "",
            quantity: "ThermalConductivity",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 1,
            name: "finsthickness",
            group: "",
            quantity: "Length",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: "finsfouling",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=fins-definition.js.map